/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description GuarantorSelect
 */
import { Button, Input } from 'antd';
import GuarantorTableModal from 'components/payments/recordPayment/GuarantorTableModal';
import { useCallback, useState } from 'react';

export interface IProps {
	value?: PatientPayment.IGuarantor;
	onChange?: (value: PatientPayment.IGuarantor) => void;
}
const GuarantorSelect: React.FC<IProps> = ({ value, onChange }) => {
	const [open, setOpen] = useState(false);

	const renderButton = useCallback(() => {
		return (
			<>
				<Button
					type='link'
					style={{ textDecoration: 'underline', padding: 0 }}
					onClick={() => {
						setOpen(true);
					}}
				>
					{value?.name ? 'Change Guarantor' : 'Search for Guarantor or Patient'}
				</Button>
				{open && (
					<GuarantorTableModal
						value={value}
						onSelect={(newValue) => {
							setOpen(false);
							onChange(newValue);
						}}
						onCancel={() => setOpen(false)}
					/>
				)}
			</>
		);
	}, [value, open, onChange]);

	if (value?.reference) {
		return (
			<>
				<Input disabled value={value?.name} readOnly />
				{renderButton()}
			</>
		);
	}
	return renderButton();
};

export default GuarantorSelect;
